<div [formGroup]="form">
  <editor [formControlName]="passFormControlName" [init]="init"></editor>
</div>
